import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";

const changeVendor = async (quoteId: number, vendorId: number) => {
  return await axiosInstance
    .patch(`quotes/updateVendor/${quoteId}`, { vendorId })
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};
const useChangeVendor = () => {
  return useMutation({
    mutationFn: ({
      quoteId,
      vendorId,
    }: {
      quoteId: number;
      vendorId: number;
    }) => changeVendor(quoteId, vendorId),
    mutationKey: ["quote"],
  });
};
export default useChangeVendor;
